// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1956":"d731eec55d7b7bda","2888":"68ee3b150421e666","4619":"61dc4172eb957eda"}[chunkId] + ".css";
};